import { ImageElement, VideoElement } from "components/UiElement";
import { ext } from "helpers";
import { Card } from "react-bootstrap";
import { Link } from "react-router-dom";
import { checkValidData, dayJsDateFormatter } from "utils";

function MapCard({
  handleClose,
  item,
  index,
  length,
  setShow,
  setDescription,
  button,
  setData,
  openImageModal,
}) {
  const imgName = (media) => {
    if (media) {
      let name = media?.substring(media?.lastIndexOf("/") + 1);
      return name;
    }
  };

  const openPdf = (pdfUrl) => {
    window.open(pdfUrl, "_blank");
  };

  return (
    <Card className="position-relative border-0 rounded-0">
      <Link className="closeBtn" onClick={handleClose}>
        <em className="icon-close" />
      </Link>
      <Card.Header className="bg-white">
        <div
          className="profileImg d-flex align-items-center position-relative cursor-pointer"
          onClick={
            ["image", "video", "audio"].includes(
              ext?.[item?.albumImageUrl?.split(".")?.pop()]
            )
              ? () => {
                  openImageModal(item?.id);
                  setData(item);
                }
              : null
          }
        >
          {ext?.[item?.albumImageUrl?.split(".")?.pop()] === "image" && (
            <ImageElement
              className="img-fluid w-100 h-100 object-fit-cover"
              previewSource={item?.albumImageUrl}
            />
          )}
          {ext?.[item?.albumImageUrl?.split(".")?.pop()] === "video" && (
            <>
              <Link to="#" className="landmakrPlay">
                <em className="icon-video" />
              </Link>
              <VideoElement
                previewSource={item?.albumImageUrl}
                extraClassName="h-100 w-100 object-fit-cover"
                alt="timeline-img"
                controls={false}
                autoPlay={false}
              />
            </>
          )}
          {ext?.[item?.albumImageUrl?.split(".").pop()] === "file" && (
            <div
              className="pdfCard pdfCardMap position-relative d-flex align-items-center justify-content-center flex-column w-100 h-100"
              onClick={() => openPdf(item?.albumImageUrl)}
              style={{ cursor: "pointer" }}
            >
              <div className="pdfCardMap_icon ">
                <em className="icon-pdf" />
              </div>
              <h6 className="pdfCard_title text-center mb-0 text-break">
                {imgName(item?.media)}
              </h6>
            </div>
          )}
          {ext?.[item?.albumImageUrl?.split(".").pop()] === "audio" && (
            <div className="audioCardMap position-relative d-flex align-items-center justify-content-center flex-column w-100 h-100">
              <div className="audioCardMap_icon">
                <em className="icon-mic" />
              </div>
              <h6 className="pdfCard_title text-center mb-0 text-break">
                {imgName(item?.media)}
              </h6>
              <Link
                className="viewBtn"
                to={item?.albumImageUrl}
                target="_blank"
              >
                {}
              </Link>
            </div>
          )}
        </div>
      </Card.Header>
      <Card.Body className="bg-white">
        <span className="d-block date">
          {dayJsDateFormatter(item?.date, "MMM DD, YYYY")}
        </span>
        <h3>{checkValidData(item?.title)}</h3>
        <span className="location">
          <em className="icon-location me-1" />
          {checkValidData(item?.location)}
        </span>{" "}
        <div className="content">
          <p>
            <span>
              {checkValidData(
                item?.description && item.description.substring(0, 130)
              )}
            </span>
            {item?.description && item.description.length > 130 && (
              <>
                <Link
                  to="#"
                  onClick={(e) => {
                    e.preventDefault();
                    setShow(true);
                    setDescription(item?.description);
                  }}
                >
                  Read more
                </Link>
              </>
            )}
          </p>
        </div>
      </Card.Body>
      <Card.Footer className="bg-white d-flex justify-content-between align-items-end count">
        <div className="me-1 count_txt">
          <span>{index + 1} </span>/ {length}
        </div>
        {button}
      </Card.Footer>
    </Card>
  );
}

export default MapCard;
